import axios from 'axios'

import { HealthcheckServiceApi } from '../../publish/healthcheck/apis/healthcheck-service-api'
import { Configuration } from '../../publish/healthcheck/configuration'
import { setupAxiosInterceptors } from '../axios-interceptor-utils'

export class HealthcheckService extends HealthcheckServiceApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
